import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { primeiroAcessoRoute, toLogout } from '../../library/Routes';
import { getToken } from '../../services/AuthService';
import { authLoadUserData } from '../../store/modules/AuthActions';
import { openModal } from '../../store/modules/ModalActions';
import {
  HTTP_STATUS_CODE_FIRST_ACCESS,
  isAuthorizedRequest,
  isFirstAccess,
} from '../../utils/httpResponseHandlers';
import SingleAlertModal from '../SingleAlertModal/SingleAlertModal';
import api from '../../services/api';
import jwtDecode from 'jwt-decode';
import './AuthRender.scss';
import ModalConfirm from 'pages/Contratos/components/ModalConfirm';
class AuthRender extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startingHidden: this.props.auth.userData ? true : false,
    };
  }

  getAccessLink = () => {
    return <a className='link' href="https://acessos.sicredi.net/" target="_blank">acesso inteligente</a>
  };

  showAccessDeniedModal = () => {
    this.props.openModal(ModalConfirm, {
      title: this.props.languageValues.modalAuthAccessErrorTitle,
      content: (
        <Fragment>
          <span>{this.props.languageValues.modalAuthAccessErrorDescription} {this.getAccessLink()}.</span>
        </Fragment>
      ),
      confirmLabel: this.props.languageValues.modalAuthAccessErrorCloseButton,
      confirmCallback: () => {
        this.props.toLogout(this.props.history);
      },
      closeCallbackIcon: () => {
        this.props.toLogout(this.props.history);
      },
      showCancelButton: false,
      modalKey: 'modalUsuarioNegado',
      maxWidth: 'sm'
    });
  };

  showErrorModal = (errorMessage) => {
    this.props.openModal(SingleAlertModal, {
      title: this.props.languageValues.modalAuthGenericErrorTitle,
      content: errorMessage,
      closeCallback: () => {
        this.props.toLogout(this.props.history);
      },
    });
  };

  redirectExpiredToken = () => {
    this.props.toLogout(this.props.history);
  };

  normalizePath(path) {
    return path.replace(/\/\/+/g, '/');
  }

  authLoadUserData = () => {
    const token = getToken();
    this.props.authLoadUserData(
      null,
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          if (!isFirstAccess(error.response)) {
            this.showErrorModal(
              error && error.response
                ? error.response.statusText
                : this.props.languageValues.errorDecodeTokenFromBackend
            );
          }
        } else {
          this.showAccessDeniedModal();
        }
      },
      () => {
        if (token) {
          try {
            const user = jwtDecode(token).sub;
            const path = this.normalizePath(primeiroAcessoRoute.path);
            this.props.history.push(path + '?user=' + user);
          } catch (error) {
            this.showErrorModal(
              error.message ||
              this.props.languageValues.errorDecodeToken +
              '(' +
              HTTP_STATUS_CODE_FIRST_ACCESS +
              ')'
            );
          }
        }
      }
    );
  };

  componentDidMount() {
    if (!this.props.auth.userData) {
      this.authLoadUserData();
    }
    this.responseInterceptor = api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          this.handleUnauthorized();
        }
        return Promise.reject(error);
      }
    );
  }

  componentWillUnmount() {
    api.interceptors.response.eject(this.responseInterceptor);
  }

  handleUnauthorized = () => {
    this.redirectExpiredToken();
  };

  getContent = (children) => {
    return children;
  };

  render() {
    return this.props.auth.userData ? this.getContent(
      <>
        {this.props.children}
      </>
    )
      : null;
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      authLoadUserData,
      openModal,
      toLogout,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AuthRender));